/**
 * @generated SignedSource<<d5c1a729a722ee083c5a6d96e9d3f5ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateMultipleAllocationsInput = {
  projectId?: string | null;
  idleTimeId?: string | null;
  projectGroupId?: string | null;
  allocations?: ReadonlyArray<CreateAllocationInputType | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateAllocationInputType = {
  personId?: string | null;
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  endYear?: number | null;
  endMonth?: number | null;
  endDay?: number | null;
  monday?: number | null;
  tuesday?: number | null;
  wednesday?: number | null;
  thursday?: number | null;
  friday?: number | null;
  saturday?: number | null;
  sunday?: number | null;
  description?: string | null;
  idleTimeId?: string | null;
  projectId?: string | null;
  projectGroupId?: string | null;
  isSoft?: boolean | null;
};
export type createMultipleAllocationsMutation$variables = {
  input: CreateMultipleAllocationsInput;
};
export type createMultipleAllocationsMutation$data = {
  readonly createMultipleAllocations: {
    readonly project: {
      readonly id: string;
    } | null;
  } | null;
};
export type createMultipleAllocationsMutation = {
  variables: createMultipleAllocationsMutation$variables;
  response: createMultipleAllocationsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMultipleAllocationsPayload",
    "kind": "LinkedField",
    "name": "createMultipleAllocations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createMultipleAllocationsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createMultipleAllocationsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e59f6e06f0afc438e8b97b8abc4b98b9",
    "id": null,
    "metadata": {},
    "name": "createMultipleAllocationsMutation",
    "operationKind": "mutation",
    "text": "mutation createMultipleAllocationsMutation(\n  $input: CreateMultipleAllocationsInput!\n) {\n  createMultipleAllocations(input: $input) {\n    project {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d0b603fa83afa6afbee98fa74a1ae00";

export default node;
